export default __webpack_public_path__ + "static/media/logo.f7282980.png";